let nextId = 0;
export const newRubricId = (prefix) => `${prefix}-${Date.now()}-${nextId++}`;

export const SCORES = [5, 4, 3, 2, 1];
export const PASS_FAIL_SCORES = ["pass", "fail"];

export const OVERALL_RATING_PLACEHOLDERS = {
    5: {
        label: "Strong yes",
        text: "Exceptional evidence across every critical competency.",
    },
    4: {
        label: "Yes",
        text: "Strong evidence with no material gap in an essential area.",
    },
    3: {
        label: "Maybe",
        text: "Qualified for the role, with gaps worth probing live.",
    },
    2: {
        label: "Lean no",
        text: "Relevant strengths, but material shortfalls remain.",
    },
    1: {
        label: "No",
        text: "Fundamental misalignment with critical role requirements.",
    },
};

export const emptyScoring = () =>
    SCORES.reduce((acc, score) => ({ ...acc, [score]: "" }), {});

export const emptyPassFailScoring = () => ({ pass: "", fail: "" });

export const analysisCriteriaToDraft = (criteria) => {
    if (!criteria) return null;
    return {
        id: criteria.id,
        version: criteria.version,
        source: criteria.source,
        caps: (criteria.score_caps || []).map((cap) => ({
            ...cap,
            max: cap.ceiling,
        })),
        bypasses: (criteria.bypass_rules || []).map((rule) => ({ ...rule })),
        overall: SCORES.reduce((result, score) => {
            const value = criteria.overall_rating_context?.[score] || {};
            result[score] = {
                label: value.label || "",
                text: value.description || "",
            };
            return result;
        }, {}),
    };
};

export const draftToAnalysisCriteria = (draft) => ({
    score_caps: draft.caps.map(({ id, rule, max, kind }) => ({
        id,
        rule,
        ceiling: max,
        kind,
    })),
    bypass_rules: draft.bypasses.map(({ id, rule }) => ({ id, rule })),
    overall_rating_context: SCORES.reduce((result, score) => {
        result[score] = {
            label: draft.overall[score].label,
            description: draft.overall[score].text,
        };
        return result;
    }, {}),
});
